import { render, staticRenderFns } from "./Ratings2023Config.vue?vue&type=template&id=bf0242b0&scoped=true"
import script from "./Ratings2023Config.vue?vue&type=script&lang=js"
export * from "./Ratings2023Config.vue?vue&type=script&lang=js"
import style0 from "./Ratings2023Config.vue?vue&type=style&index=0&id=bf0242b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0242b0",
  null
  
)

export default component.exports